<template>
    <div class="rlms-container terms-page">
        <div class="content">
            <h1>Terms and Conditions</h1>
            <p>
                <strong>Effective Date:</strong> {{ doc.effective }}
                &nbsp;·&nbsp; <strong>Version:</strong> {{ doc.version }}
            </p>
            <div class="rlms-bg-danger-100 rlms-flex rlms-gap-10 rlms-items-center rlms-p-5 rlms-rounded rlms-mb-5"
                style="border-radius: 16px;">
                <span class="material-symbols-outlined" style="color: red;"> warning </span>
                <p class="rlms-text-error-darkest rlms-fw-500">Notice to user: Please read this agreement carefully.</p>
            </div>


            <p>EESAPP SOFTWARE LICENSE AGREEMENT</p>

            <section>
                <h2>1. DEFINITIONS</h2>
                <p class="rlms-mb-5">
                    Agreement means this DMTD App End User Software License Agreement. - "APP Run-Time" means that
                    portion of the Software required for the End User Product to operate on hardware where the Software
                    itself is not resident. - "Device" means a virtual or physical computer that accepts information in
                    digital form and manipulates it based on a sequence of instructions. - "DMTD" means Data Makes the
                    Difference, LLC, a Pennsylvania limited liability company, 17 Greystone Drive, Mountain Top, PA
                    18707. - "End User Product" means an Output File containing content generated by you, such as
                    charts, graphs, data, analysis, notes, and similar materials. - "Output File" means an output file
                    generated by you using the Software. - "Permitted Number" means one (1) unless otherwise indicated
                    under a valid license granted by DMTD. - "Software" means all information accompanying this
                    Agreement, including but not limited to: - (i) Applications distributed by DMTD, including the
                    EESAPP App and other apps - (ii) Content Files (sample and stock materials bundled with DMTD
                    applications) - (iii) Documentation (written materials and files) - (iv) Updates (modifications,
                    upgrades, and additions provided by DMTD) - "You" means you individually, or the corporation or
                    other entity on whose behalf you are using the Software.
                </p>
                <p>*Other terms may be defined throughout this Agreement and shall have the meanings given to them in
                    context.*</p>
            </section>

            <section>
                <h2>2. LICENSE GRANT AND RESTRICTIONS</h2>
                <p class="rlms-mb-5">
                    <b>2.1</b> License Grant If you obtained the Software from DMTD or one of its authorized licensees,
                    and
                    comply with the terms of this Agreement, DMTD grants you a non-exclusive license to use the Software
                    as described in the Documentation and as set forth below.
                </p>
                <p class="rlms-mb-5">
                    <b>2.2</b> Installation and Use As long as you have at least one active license associated with your
                    account, you may install and use the Software on any compatible Devices.
                </p>
                <p class="rlms-mb-5">
                    <b>2.3</b> Use of End User Products You may make copies of the End User Product only for use by or
                    with the
                    specific learner for which the End User Product was generated. You may not: - Modify or alter any
                    End User Product - Generate content based on the End User Product for use with other learners - Use
                    the End User Product for any other purpose or distribute it to others
                </p>
                <p class="rlms-mb-5">
                    <b>2.4</b> Content Files You may not modify, reproduce, or distribute any Content Files except as
                    permitted
                    in the associated "Read-Me" files. Content Files may not be used to create: - Libelous or defamatory
                    material - Fraudulent, lewd, obscene, or pornographic material - Material that infringes third-party
                    intellectual property rights - Any other unlawful material
                </p>
                <p class="rlms-mb-5">
                    <b>2.5</b> Prices for Software licenses are subject to change at DMTD’s discretion. DMTD reserves
                    the right
                    to adjust pricing for new purchases, renewals, or additional services at any time. Any such changes
                    will not affect the duration or features of active licenses already purchased.
                </p>
                <p class="">
                    You may not claim any trademark rights in the Content Files or derivative works thereof.
                </p>
            </section>

            <section>
                <h2>3. INTELLECTUAL PROPERTY OWNERSHIP</h2>
                <p class="rlms-mb-5">
                    The Software and any authorized copies are the intellectual property of DMTD and its suppliers. The
                    structure, organization, and code of the Software are valuable trade secrets and confidential
                    information of DMTD. The Software is protected by copyright laws and international treaty
                    provisions.
                </p>
                <p class="">
                    This Agreement does not grant you any intellectual property rights in the Software beyond those
                    expressly stated. All rights not expressly granted are reserved by DMTD and its suppliers.
                </p>
            </section>

            <section>
                <h2>4. FEEDBACK</h2>
                <p>
                    If you send any communications to DMTD suggesting changes to the Software or Documentation
                    ("Feedback"), DMTD is free to use such Feedback without obligation. You assign to DMTD all rights,
                    title, and interest in any ideas, know-how, concepts, techniques, or other intellectual property
                    rights contained in the Feedback, for any purpose whatsoever, without attribution or compensation.
                </p>
            </section>

            <section>
                <h2>5. COPYING AND TRANSFERABILITY RESTRICTIONS</h2>
                <p class="rlms-mb-5">
                    <b>5.1</b> Copying Any permitted copy of the Software must contain the same copyright and
                    proprietary notices that appear on or in the Software.
                </p>
                <p class="rlms-mb-5">
                    <b>5.2</b> No Modifications You may not modify, adapt, or translate the Software except as may be
                    permitted in Section 13.
                </p>
                <p class="rlms-mb-5">
                    <b>5.3</b> No Reverse Engineering You will not reverse engineer, decompile, disassemble, or
                    otherwise attempt to discover the source code of the Software except to the extent expressly
                    permitted by applicable law solely to achieve interoperability with the Software.
                </p>
                <p class="rlms-mb-5">
                    <b>5.4</b> Component Integrity The Software is designed and provided as a single product. You may
                    not unbundle or repackage the component parts for use on different Devices or for distribution,
                    transfer, or resale.
                </p>
                <p class="rlms-mb-5">
                    <b>5.5</b> No Transfer YOU WILL NOT RENT, LEASE, SELL, SUBLICENSE, ASSIGN OR TRANSFER YOUR RIGHTS IN
                    THE SOFTWARE, OR AUTHORIZE ANY PORTION OF THE SOFTWARE TO BE COPIED ONTO ANOTHER INDIVIDUAL OR LEGAL
                    ENTITY'S DEVICE EXCEPT AS EXPRESSLY PERMITTED HEREIN.
                </p>
                <p class="">
                    <b>5.6</b> No Service Bureau Use You will not use or offer the Software on a service bureau basis or
                    permit third parties to utilize your instance of the Software for their benefit.
                </p>
            </section>

            <section>
                <h2>6. UPDATES AND UPGRADES</h2>
                <p>
                    DMTD may release updates or upgrades to the Software. You may be required to install these updates
                    or upgrades at DMTD's discretion. Updates and upgrades may be subject to additional or different
                    terms.
                </p>
            </section>

            <section>
                <h2>7. LIMITED WARRANTY</h2>
                <p class="rlms-mb-5">
                    <b>7.1</b> Performance Warranty Subject to the limitations in this Section and Section 8, DMTD
                    warrants to the individual or entity that first purchases a license that the Software will perform
                    substantially in accordance with the Documentation for ninety (90) days following your receipt of
                    the Software, provided it is used on the recommended operating system and hardware configuration.
                    <br />
                    <br />
                    Non-substantial variation of performance from the Documentation does not establish a warranty right.
                </p>
                <p class="rlms-mb-5">
                    <b>7.2</b> Warranty Exclusions THIS LIMITED WARRANTY DOES NOT APPLY TO PATCHES, PRE-RELEASE (BETA),
                    TRYOUT, STARTER, EVALUATION, PRODUCT SAMPLER, OR NOT FOR RESALE (NFR) COPIES OF SOFTWARE, OR TO ANY
                    WEBSITES, ONLINE SERVICES, OR CONTENT DELIVERED AS PART OF THE SOFTWARE (see Section 13 for specific
                    exceptions).
                </p>
                <p class="rlms-mb-5">
                    <b>7.3</b> Warranty Claims All warranty claims must be made with proof of purchase to the DMTD
                    Customer Support Department within the ninety (90) day warranty period. Visit www.datamtd.com for
                    warranty claim information.
                </p>
                <p>
                    <b>7.4</b> Exclusive Remedy If the Software does not perform substantially in accordance with the
                    Documentation during the warranty period, DMTD's entire liability and your exclusive remedy will be
                    limited to either replacement of the Software or a refund of the license fee, at DMTD's option.
                </p>
            </section>

            <section>
                <h2>8. WARRANTY DISCLAIMER AND LIABILITY LIMITATION</h2>
                <p class="rlms-mb-5">
                    <b>8.1</b> Warranty Disclaimer THE FOREGOING LIMITED WARRANTY IS THE ONLY WARRANTY MADE BY DMTD AND
                    STATES THE SOLE REMEDIES FOR ANY BREACH OF WARRANTY. EXCEPT FOR THE LIMITED WARRANTY AND ANY
                    WARRANTY THAT CANNOT BE EXCLUDED BY LAW, DMTD PROVIDES THE SOFTWARE AND ACCESS TO ANY WEBSITES AND
                    ONLINE SERVICES "AS IS" AND "WITH ALL FAULTS" AND EXPRESSLY DISCLAIMS ALL OTHER WARRANTIES, EXPRESS
                    OR IMPLIED, INCLUDING MERCHANTABILITY, NON-INFRINGEMENT, INTEGRATION, QUIET ENJOYMENT, SATISFACTORY
                    QUALITY, AND FITNESS FOR ANY PARTICULAR PURPOSE.
                </p>
                <p class="rlms-mb-5">
                    <b>8.2</b> Liability Limitation EXCEPT FOR THE EXCLUSIVE REMEDY IN SECTION 7.4 AND AS OTHERWISE
                    PROVIDED IN SECTION 13, DMTD, ITS AFFILIATES, SUPPLIERS, AND CERTIFICATE AUTHORITIES WILL NOT BE
                    LIABLE FOR ANY LOSS, DAMAGES, CLAIMs, OR COSTS WHATSOEVER, INCLUDING CONSEQUENTIAL, INDIRECT, OR
                    INCIDENTAL DAMAGES, LOST PROFITS, BUSINESS INTERRUPTION, PERSONAL INJURY, OR THIRD-PARTY CLAIMS,
                    EVEN IF DMTD HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                </p>
                <p>
                    DMTD'S AGGREGATE LIABILITY UNDER OR IN CONNECTION WITH THIS AGREEMENT WILL BE LIMITED TO THE AMOUNT
                    PAID FOR THE SOFTWARE, IF ANY. These limitations apply to the maximum extent permitted by applicable
                    law in your jurisdiction.
                </p>
            </section>
            <section>
                <h2>9. EXPORT RULES</h2>
                <p>
                    You agree that the Software will not be shipped, transferred, or exported into any country or used
                    in any manner prohibited by United States export laws and regulations (collectively, "Export Laws").
                    If the Software is identified as an export-controlled item, you represent that you are not located
                    in an embargoed nation and are not otherwise prohibited under the Export Laws from receiving the
                    Software. All rights to use the Software are granted on condition that such rights are forfeited if
                    you fail to comply with this Agreement.
                </p>
            </section>
            <section>
                <h2>10. GOVERNING LAW</h2>
                <p>
                    This Agreement will be governed by the substantive laws of the Commonwealth of Pennsylvania. The
                    state and federal courts of Luzerne County, Pennsylvania shall have exclusive jurisdiction over all
                    disputes relating to this Agreement. This Agreement will not be governed by any conflict of law
                    principles or by the U.N. Convention on Contracts for the International Sale of Goods, which is
                    expressly excluded.
                </p>
            </section>
            <section>
                <h2>11. GENERAL PROVISIONS</h2>
                <p>
                    If any part of this Agreement is found void or unenforceable, it will not affect the validity of the
                    rest of the Agreement, which will remain in effect according to its terms. This Agreement may only
                    be modified by a writing signed by an authorized DMTD officer. This Agreement, together with any
                    separate volume-license or other written agreement between you and DMTD, constitutes the entire
                    agreement between you and DMTD regarding the Software and supersedes all prior representations,
                    discussions, and communications related to the Software.
                </p>
            </section>
            <section>
                <h2>12. CONNECTIVITY AND PRIVACY</h2>
                <p>
                    <b>12.1</b> Automatic Internet Connections The Software may cause your Device to automatically
                    connect to the
                    Internet to check for updates and upgrades and to notify DMTD of successful installation. Only
                    non-personal identifying information is transmitted. Your communications with DMTD websites are
                    governed by DMTD's Terms of Service and Privacy Policy (available at www.datamtd.com). Please
                    consult the Documentation for information about changing default update settings.
                </p>
            </section>
            <section>
                <h2>13. SPECIFIC PROVISIONS AND EXCEPTIONS</h2>
                <p class="rlms-mb-5">
                    <b>13.1</b> Pre-release Software Pre-release Software is a pre-release version, not a final product,
                    and may contain bugs, errors, and other problems that could cause system failures and data loss.
                    DMTD may never commercially release the Pre-release Software. Your use of Pre-release Software is AT
                    YOUR OWN RISK. If you received Pre-release Software under a separate written agreement, that
                    agreement will also govern your use. You agree to return or destroy all copies of the Pre-release
                    Software upon DMTD’s request or upon DMTD’s commercial release of such Software. _(This provision
                    requiring the return or destruction of Pre-release Software copies has been added to align with the
                    previous version.)_ WARRANTY DISCLAIMERS AND LIABILITY LIMITATIONS IN SECTIONS 7 AND 8 GOVERN
                    PRE-RELEASE SOFTWARE.
                </p>
                <p class="rlms-mb-5">
                    <b>13.2</b> Tryout Software Tryout, starter, product sampler, or NFR ("Not for Resale") Software may
                    contain limited functionality and is to be used for demonstration and evaluation purposes only, and
                    not for your commercial purposes. YOUR USE OF TRYOUT SOFTWARE IS AT YOUR OWN RISK. WARRANTY
                    DISCLAIMERS AND LIABILITY LIMITATIONS IN SECTIONS 7 AND 8 GOVERN TRYOUT SOFTWARE.
                </p>
                <p class="rlms-mb-5">
                    <b>13.3</b> Timeout Software If the Software is a timeout or trial version, then it will cease
                    operation after a designated period of time or number of launches following installation. The
                    license granted under this Agreement will terminate after such period or number of launches, unless
                    extended by DMTD upon your acquisition of a full retail license. ACCESS TO ANY FILES OR OUTPUT
                    CREATED WITH SUCH SOFTWARE IS ENTIRELY AT YOUR OWN RISK.
                </p>
                <p class="rlms-mb-5">
                    <b>13.4 Online Services</b>
                </p>
                <p class="rlms-mb-5">
                    <b>13.4.1</b> DMTD Online Services The Software may rely upon websites maintained by DMTD, its
                    affiliates, or third parties offering goods, information, software, and services (collectively,
                    "Online Services"). To the extent the Software is integrated into a website owned or operated by
                    DMTD, such integration is considered part of the Software and your use of that website is governed
                    by the terms of this Agreement and any other applicable terms of use for that website. Your access
                    to and use of any websites or online services not operated by DMTD is governed by the terms,
                    conditions, disclaimers, and notices found on such third-party sites or services.
                </p>
                <p class="rlms-mb-5">
                    <b>13.4.2</b> Third-Party Websites DMTD does not control, endorse, or accept responsibility for
                    websites or Online Services offered by third parties. Any dealings between you and any third party
                    in connection with a third-party website or Online Service, including delivery of and payment for
                    goods or services and any other terms, conditions, warranties, or representations associated with
                    such dealings, are solely between you and the third party.
                </p>
                <p>
                    <b>13.4.3</b> Online Services Disclaimer EXCEPT AS EXPRESSLY AGREED BY DMTD, ITS AFFILIATES, OR A
                    THIRD PARTY IN A SEPARATE AGREEMENT, YOUR USE OF WEBSITES AND ONLINE SERVICES IS AT YOUR OWN RISK
                    UNDER THE WARRANTY AND LIABILITY LIMITATIONS OF SECTIONS 7 AND 8.
                </p>
            </section>
            <section>
                <h2>14. INDEMNIFICATION</h2>
                <p class="rlms-mb-5">
                    <b>14.1</b> Your Indemnification Obligations You agree to indemnify, defend, and hold harmless DMTD,
                    its affiliates, licensors, suppliers, advertisers, and sponsors, and each of their directors,
                    officers, employees, consultants, and agents, from and against any and all liabilities, damages,
                    claims, costs, or losses (including reasonable attorneys' fees) arising out of or relating to your
                    use of or reliance on the Software or Online Services, including any analysis of data created by the
                    Software. _(Clarifies that this indemnity covers DMTD's licensors, suppliers, advertisers, and
                    sponsors, and includes attorneys' fees, as in the older version.)_
                </p>
                <p class="rlms-mb-5">
                    <b>14.2 DMTD's Indemnification Obligations</b>
                </p>
                <p class="rlms-mb-5">
                    <b>14.2.1</b> Indemnification for Infringement DMTD shall indemnify, defend, and hold you harmless
                    from losses resulting from any third-party claim that the Software or Documentation infringes U.S.
                    patents, copyrights, or trade secrets, provided you promptly notify DMTD in writing of the claim,
                    cooperate with DMTD, and allow DMTD to control the defense and settlement of such claim.
                </p>
                <p class="rlms-mb-5">
                    <b>14.2.2</b> Remedies for Infringement Claims If such a claim is made or appears possible, DMTD
                    may, at its discretion: - Modify or replace the Software or Documentation to make it non-infringing,
                    or - Obtain the right for you to continue using the affected Software or Documentation.<br /> If
                    DMTD determines that neither alternative is reasonably available, DMTD may terminate this Agreement
                    immediately upon written notice to you.
                </p>
                <p class="rlms-mb-5">
                    <b>14.2.3</b> Exclusions from Indemnification DMTD's indemnification obligations do not apply to the
                    extent an infringement claim arises from: - Use of the Software with data, software, hardware, or
                    technology not provided or authorized by DMTD - Modifications to the Software not made by DMTD - Use
                    of a version of the Software or Documentation other than the most current version provided to you.
                </p>
                <p>
                    <b>14.2.4</b> 4 Sole Remedy THIS SECTION 14 SETS FORTH YOUR SOLE REMEDIES AND DMTD'S SOLE LIABILITY
                    FOR ANY ACTUAL, THREATENED, OR ALLEGED INTELLECTUAL PROPERTY INFRINGEMENT CLAIMS.
                </p>
            </section>
            <section>
                <h2>15. TERMINATION</h2>
                <p class="rlms-mb-5">
                    Without prejudice to other rights, DMTD may terminate this Agreement if you fail to comply with its
                    terms and such failure is not cured within thirty (30) days of notice. Upon termination, the license
                    granted hereunder will also terminate, and you must cease using and delete or destroy all copies of
                    the Software and Documentation and certify this to DMTD in writing.
                </p>
                <p class="rlms-mb-5">
                    Termination will not affect your obligation to pay all fees due before termination or entitle you to
                    any refund.
                </p>
                <p>
                    Sections 7 (Limited Warranty) and 8 (Warranty Disclaimer and Liability Limitation) shall survive any
                    termination or expiration of this Agreement. _(Sections 7 and 8 surviving termination was explicitly
                    stated in the older version.)_
                </p>
            </section>
            <section>
                <h2>16. CONTACT INFORMATION</h2>
                <p>
                    For questions or information requests, contact DMTD using the address and contact information
                    included with this product.
                </p>
            </section>
            <section>
                <h2>17. TRADEMARKS</h2>
                <p>
                    EESAPP App™, EFL App™, VBMAPP App™, and DMTD App™ are trademarks of Data Makes the Difference, LLC.
                </p>
            </section>

            <section>
                <h2>18. RECORDINGS, AI AND YOUR RESPONSIBILITIES</h2>
                <p class="rlms-mb-5">
                    <b>18.1 What this section covers.</b> EESAPP lets you record a learner's speech and have it
                    analysed to help you score an assessment. This section is about those recordings and that analysis.
                    It applies to you and to everyone in your organization.
                </p>
                <p class="rlms-mb-5">
                    <b>18.2 Your promise to us about consent.</b> You will only record a learner where you have the
                    written permission of their parent or legal guardian, and any further permission required by your
                    employer, your school or district, your professional body or the law where you practise. You will
                    keep a record of that permission and produce it if we are ever asked. You will stop recording, and
                    delete recordings on request, if that permission is withdrawn. You are responsible for telling
                    parents and guardians that recordings are made and analysed as described in our privacy policy.
                    <b>We do not collect this permission and cannot check it. Recording a learner without it is a
                        breach of these terms.</b>
                </p>
                <p class="rlms-mb-5">
                    <b>18.3 Who is responsible for the learner's data.</b> You decide what learner information goes
                    into EESAPP and why. We hold and process it for you, to provide the service, on your instructions,
                    and for nothing else. Where the law calls you a controller and us a processor (or you a school and
                    us a school official, or you a covered entity and us a business associate), that is the
                    relationship between us.
                </p>
                <p class="rlms-mb-5">
                    <b>18.4 What we do with recordings.</b> We store them encrypted in our own cloud account and
                    analyse them with speech software we run ourselves, to produce a transcript, per-sound marks and
                    sometimes a suggested score. We do not send recordings to any AI company. We do not sell them,
                    share them with other customers, or use them for advertising. We keep a recording, its transcript,
                    the per-sound marks and the score until you delete them — a recording, an assessment, a learner or
                    the whole account — or until your account is closed; nothing is deleted because of its age, and
                    what you delete is deleted promptly. Our privacy policy says exactly who can listen to a
                    recording, what we keep and how we delete it.
                </p>
                <p class="rlms-mb-5">
                    <b>18.5 Permission to help improve the AI is separate, and off by default.</b> Your organization's
                    administrator can switch on a setting called "Allow de-identified recordings to help improve the
                    AI". It is off unless they switch it on, and they can switch it off again whenever they like.
                    Switching it on is not a condition of using EESAPP and changes nothing about how the assessment
                    works. By switching it on, your organization confirms that the permissions it holds from parents
                    and guardians cover this use. Switching it off stops any further use of your recordings. We cannot
                    remove information from a model that has already been trained, and we will say plainly, before
                    anyone switches it on, what is taken and what is removed from it first.
                </p>
                <p class="rlms-mb-5">
                    <b>18.6 The AI assists you; it does not assess.</b> Transcripts, per-sound marks, suggested scores,
                    suggested practice words and word-shell steps are suggestions produced by software, and software
                    mishears children. You remain professionally responsible for every score and every clinical
                    decision. Check them. Do not rely on EESAPP as a diagnosis.
                </p>
                <p class="rlms-mb-5">
                    <b>18.7 Do not type identifying information into the AI boxes.</b> The preference boxes used to
                    suggest practice words are free text and are sent to the model as typed. Do not enter a learner's
                    name, a family member's name, a school, an address or anything else that identifies them.
                </p>
                <p class="rlms-mb-5">
                    <b>18.8 HIPAA.</b> Where we have entered into a Business Associate Agreement with you, its terms
                    govern our handling of protected health information and override anything inconsistent in these
                    terms. If you are a covered entity under HIPAA and do not yet have one with us, contact us.
                </p>
                <p class="rlms-mb-5">
                    <b>18.9 Schools and districts.</b> Where your organization is a school, district or other
                    educational agency, additional terms apply to student records, including your designation of us as
                    a school official with a legitimate educational interest and our undertaking not to disclose
                    student records further or use them for any purpose other than providing the service to you. Those
                    terms are being finalised and will be published here before this section is relied on by an
                    educational customer.
                </p>
                <p>
                    <b>18.10 Changes to these terms.</b> These terms and our privacy policy carry a version. When we
                    change either in a way that affects recordings or AI, we will ask you to accept the new version the
                    next time you sign in. Until you accept, the AI features — automatic transcription and the
                    suggested practice words — are switched off. Everything else keeps working: you can carry on
                    assessing, scoring by hand, recording, and reading your results.
                </p>
            </section>

            <section>
                <p class="rlms-mb-5">
                    TERMS OF SERVICE AND LEGAL DISCLAIMER
                </p>
                <p class="rlms-mb-5">
                    GENERAL TERMS
                </p>
                <p class="rlms-mb-5">
                    Data Makes the Difference, LLC ("DMTD") owns and operates several websites, including datamtd.com,
                    vbmappapp.com, eflapp.com, and eesappapp.com (collectively, the "Sites").
                </p>
                <p class="rlms-mb-5">
                    Your use of the Sites and all products and services provided through the Sites is subject to these
                    terms, conditions, and disclaimers, to DMTD's Privacy Policy, and to all applicable laws and
                    regulations. DMTD reserves the right to terminate your access to any or all of the Sites for any
                    reason (unless otherwise agreed in writing) and to modify these terms without advance notice.
                </p>
                <p class="rlms-mb-5">
                    This is a binding contract. By accepting these Terms of Service and using the Sites, you warrant
                    that: - You are over eighteen (18) years of age; - You have provided accurate and complete
                    information in your communications with DMTD; and - You have the authority to bind the person or
                    entity on whose behalf you access the Sites.
                </p>
                <p>
                    You are granted a nonexclusive, nontransferable, limited right to access and use the Sites for
                    personal research purposes only.
                </p>
            </section>
            <section>
                <h2>ACCESS</h2>
                <p class="rlms-mb-5">
                    Access to the Sites does not create a professional services relationship with DMTD.
                </p>
                <p class="rlms-mb-5">
                    You may not: - Commercially exploit any substantial part of the Sites - Transfer or store data from
                    the Sites for use by more than one user without permission - Download, reproduce, transmit, or copy
                    materials from the Sites without permission - Exploit DMTD's goodwill, trademarks, or logos without
                    express written consent
                </p>
                <p class="rlms-mb-5">
                    For any Content you submit to the Sites (including profile information, forum posts, and emails),
                    you warrant that you own the rights to such Content. You grant DMTD a non-exclusive, worldwide,
                    paid-up, royalty-free, perpetual license to use, display, distribute, perform, reproduce, modify,
                    and create derivative works from the Content.
                </p>
                <p>
                    <b>This licence does not apply to learner information or to recordings of a learner.</b> Those are
                    held and used only as set out in section 18 (Recordings, AI and your responsibilities) above and in
                    our privacy policy.
                </p>
            </section>
            <section>
                <h2>INTELLECTUAL PROPERTY</h2>
                <p class="rlms-mb-5">
                    DMTD and the Sites, and all text and images contained on the Sites (except as otherwise identified),
                    are protected by applicable law and are the property of DMTD. All copyrights and trademarks not
                    owned by DMTD are the property of their respective owners.
                </p>
                <p class="rlms-mb-5">
                    No license or rights in any of DMTD's intellectual property are granted to you by implication,
                    laches, estoppel or otherwise, except as expressly provided. Any unauthorized use of materials on
                    the Sites may violate the law. You may not remove or obscure copyright notices or other notices on
                    any Content or on the Sites.
                </p>
                <p>
                    DMTD's products (including third-party and licensed materials on the Sites) may not be modified,
                    reproduced, republished, retransmitted, or displayed except for noncommercial, personal use. Any use
                    of such materials for a commercial or public purpose requires specific written permission from DMTD.
                </p>
            </section>
            <section>
                <h2>ACCEPTABLE USE POLICY</h2>
                <p class="rlms-mb-5">
                    You are responsible for your use of the Sites and agree not to engage in unacceptable use.
                    Unacceptable use includes, but is not limited to, using the Sites to:
                </p>
                <p class="rlms-mb-5">
                    - Disseminate spam, chain letters, advertisements, or unsolicited communications - Transmit abusive,
                    obscene, profane, defamatory, harassing, or threatening content, or any content that infringes upon
                    the rights of others or is unlawful - Share non-public business information without authorization -
                    Create false identities or otherwise mislead others as to your identity - Manipulate or attempt to
                    manipulate securities or markets, or provide information to assist in such manipulation - Interfere
                    with, disrupt, or gain unauthorized access to other accounts, networks, or services - Copy or use
                    any personally identifiable information about other users without permission - Spread viruses,
                    worms, Trojan horses, or other malicious code or programs - Imply that your statements are endorsed
                    by DMTD or its affiliates - "Hack," deface, or otherwise impair any portion of the Sites or restrict
                    any other user from using the Sites - Reverse engineer, decompile, or disassemble any portion of the
                    Sites - Remove any copyright, trademark, or proprietary rights notice from the Sites - "Frame" or
                    "mirror" any part of the Sites - Engage in any other activity that DMTD deems in conflict with the
                    spirit or intent of these Terms of Service


                </p>
                <p class="rlms-mb-5">
                    You understand that by using the Sites, you may be exposed to Content that is offensive or
                    challenges your beliefs. Your exclusive remedy is to discontinue access to the Sites.
                </p>
                <p>
                    Automated use of the Sites (via bots, scripts, etc.) is strictly prohibited. Unless otherwise agreed
                    by DMTD in writing, use of the Sites is permitted only through manually conducted, discrete
                    individual activities.
                </p>
            </section>
            <section>
                <h2>CONTENT AND NON-ENDORSEMENT</h2>
                <p class="rlms-mb-5">
                    Opinions expressed by users or third parties on the Sites are their own and do not reflect the
                    opinions of DMTD. Third-party content is the sole responsibility of the party posting it. DMTD does
                    not control or endorse information accessed through any links on the Sites and is not responsible
                    for your use of that information.
                </p>
                <p class="rlms-mb-5">
                    For copyright complaints or to report inappropriate content, please email info@datamtd.com with
                    "Inappropriate Use" in the subject line.
                </p>
                <p class="rlms-mb-5">
                    DMTD does not generally initiate, edit, or select recipients for user messages. However, DMTD may: -
                    Consolidate and edit forum content for clarity - Inform users or third parties of certain content
                    and request responses or hosts for discussions - Monitor the Sites and remove any information that
                    DMTD, in its sole discretion, considers inappropriate or unlawful (although DMTD has no obligation
                    to monitor)
                </p>
                <p>
                    By transmitting content to the Sites' forums or comment areas, you grant DMTD (and its designees) a
                    worldwide, non-exclusive, sublicensable, assignable, royalty-free, perpetual, irrevocable right to
                    use, reproduce, distribute, create derivative works from, publicly perform, publicly display, and
                    import such submissions in any media, for any purpose, without compensation to you. None of your
                    submissions will be subject to any obligation of confidentiality or attribution on the part of DMTD,
                    and DMTD will not be liable for any use or disclosure of any submissions.
                </p>
            </section>
            <section>
                <h2>FORUMS AND COMMENT AREAS</h2>
                <p class="rlms-mb-5">
                    The forums and comment areas on the Sites are designed to allow users to share ideas and opinions.
                    Information in these areas is provided by staff and other contributors (who may use anonymous screen
                    names and may not be affiliated with DMTD). You acknowledge that a large volume of information is
                    available in the forums and that some postings may be inaccurate, misleading, or offensive. DMTD
                    neither endorses nor is responsible for such content. DMTD is not liable for any loss or damage
                    caused by your reliance on information obtained through the Sites or the forums.
                </p>
                <p>
                    DMTD has no obligation to monitor the forums or comment areas, but reserves the right to: - Monitor
                    and edit or remove any materials posted - Disclose any such materials and the circumstances of their
                    transmission to any third party to operate the Sites properly, to protect DMTD and its users, or to
                    comply with legal obligations
                </p>
            </section>
            <section>
                <h2>LIMITATION OF LIABILITY</h2>
                <p class="rlms-mb-5">
                    DMTD works to ensure the accuracy of information on the Sites, but the information often relies on
                    data from many sources and DMTD cannot guarantee its accuracy or any analysis based on it. DMTD
                    shall not be liable for any loss, injury, claim, liability, or damage of any kind resulting from: -
                    Errors or omissions on the Sites or in any Content available on or through the Sites -
                    Unavailability or interruption of the Sites or any features or Content - Your use of the Sites or
                    Content - Loss or corruption of data or equipment in connection with the Sites - The content,
                    accuracy, or completeness of any Content - Any delay or failure in performance beyond the reasonable
                    control of DMTD - Your use of any analysis or results generated by the Sites or related products
                </p>
                <p class="rlms-mb-5">
                    THE SITES ARE PROVIDED "AS IS" AND "WHEN AVAILABLE" WITHOUT ANY WARRANTIES. DMTD DISCLAIMS ALL
                    IMPLIED WARRANTIES, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
                    NON-INFRINGEMENT. DMTD DOES NOT WARRANT THAT THE SITES WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
                    NO INFORMATION OR ADVICE OBTAINED THROUGH THE SITES OR FROM DMTD (BY ANY MEANS) SHALL CREATE ANY
                    WARRANTY NOT EXPRESSLY STATED IN THESE TERMS OF SERVICE.
                </p>
                <p class="rlms-mb-5">
                    DMTD SHALL NOT BE LIABLE UNDER ANY CIRCUMSTANCES FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, SPECIAL,
                    EXEMPLARY, PUNITIVE, OR OTHER DAMAGES (INCLUDING LOST PROFITS or attorneys' fees) under any legal
                    theory, including but not limited to breach of contract, breach of warranty, negligence, or strict
                    liability, regardless of whether DMTD was informed of the possibility of such damages.
                </p>
                <p>
                    You expressly agree that you use the Sites solely at your own risk.
                </p>
            </section>
            <section>
                <h2>INDEMNIFICATION</h2>
                <p>
                    You agree to indemnify, defend, and hold harmless DMTD, its affiliates, licensors, suppliers,
                    advertisers, and sponsors, and its and their directors, officers, employees, consultants, and
                    agents, from and against any and all claims, damages, losses, and costs (including reasonable
                    attorneys' fees) arising directly or indirectly from: - Your breach of this agreement or violation
                    of these Terms of Service; - Any allegation that Content you submit or transmit to the Sites
                    infringes or violates the intellectual property or other rights of any third party; and/or - Your
                    activities in connection with the Sites.
                </p>
            </section>
            <section>
                <h2>FEE-SHIFTING AND CHOICE OF LAW</h2>
                <p class="rlms-mb-5">
                    If you bring any legal action against DMTD related to its products or services (including use of the
                    Sites) and do not prevail, you agree to reimburse DMTD for all costs and attorney's fees incurred in
                    the defense of that action.
                </p>
                <p>Use of the Sites and any disputes arising from such use are governed by the laws of the Commonwealth
                    of Pennsylvania, without regard to its conflict of law principles. You agree that any claim shall be
                    brought exclusively in the state or federal courts located in Luzerne County, Pennsylvania.</p>
            </section>
            <section>
                <h2>SEVERABILITY</h2>
                <p>If any provision of these Terms is held unenforceable, the remainder of the Terms shall remain in
                    effect to the fullest extent consistent with the intent of this document.</p>
            </section>
        </div>
    </div>
</template>

<script setup>
// The words are here; their version is in src/content/legal so the text and the
// version we record someone accepting cannot drift apart.
import { LEGAL_DOCUMENTS } from '@/content/legal';

// Not named `document`: that would shadow the DOM global inside this component.
const doc = LEGAL_DOCUMENTS.terms;
</script>